export const useTransliterateText = (text: string, transliterationMapping: Record<string, string>): string => {
    return [...text].map((letter: string) => transliterationMapping[letter] || letter).join('');
};
